export default __webpack_public_path__ + "static/media/COS-BNB.8af3b024.svg";